import api from "./axios";

export interface CashDebtItem {
  id: number;
  userId: number;
  dealId: number | null;
  dealNumber: string | null;
  dealTitle: string | null;
  amount: number;
  createdAt: string;
  settledAt: string | null;
  settledBy: string | null;
  note: string | null;
}

export interface MyCashDebt {
  total: number;
  open: CashDebtItem[];
  history: CashDebtItem[];
}

export interface StaffCashDebt {
  userId: number;
  name: string;
  total: number;
  openCount: number;
  oldest: string | null;
  open: CashDebtItem[];
  history: CashDebtItem[];
}

export const CashDebtsAPI = {
  mine: () => api.get("/cash-debts/my").then((r) => r.data as MyCashDebt),
  summary: () => api.get("/cash-debts").then((r) => r.data as { grandTotal: number; staff: StaffCashDebt[] }),
  settle: (userId: number, ids?: number[], note?: string) =>
    api.post("/cash-debts/settle", { userId, ids, note }).then((r) => r.data as { settled: number }),
};

export const CashDebtsAdminAPI = {
  manual: (userId: number, amount: number, note?: string) =>
    api.post("/cash-debts/manual", { userId, amount, note }).then((r) => r.data),
  cancel: (id: number) => api.delete(`/cash-debts/${id}`).then((r) => r.data),
};
